<template>
  <div class="list-top-bar">
    <div class="btn-back" @click="goBack"></div>
    <div class="top-bar-title">{{ topTitle }}</div>
  </div>
</template>
<script>
export default {
  name: 'listTopBar',
  // props: {
  //   title: {
  //     type: String,
  //     default: ' '
  //   }
  // },
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // title: ' '
      topTitle: this.title
    };
  },
  watch: {
    title() {
      this.topTitle = this.title;
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
  created() {
    this.$eventBus.$on('listBarTitle', title => {
      this.topTitle = title;
    });
  }
};
</script>
<style lang="less" scoped>
.list-top-bar {
  width: 100%;
  text-align: center;
  background: #ffffff;
  padding: 0 0.11rem;
  box-sizing: border-box;
  height: 0.83rem;
  line-height: 0.83rem;
  position: relative;
  z-index: 99999;
  .top-bar-title {
    margin: 0 auto;
    max-width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.btn-back {
  width: 0.18rem;
  height: 0.3rem;
  position: absolute;
  left: 0.3rem;
  top: 0;
  bottom: 0;
  margin: auto 0;
  background: url('https://files.jinr.com/jinr-index/img/m-btn-back.png') no-repeat;
  background-size: 100%;
}
</style>
